export const newsItems = [
  {
    date: "Oct 2026",
    type: "presentation",
    title: "🇺🇸 Attending CSCW 2026 in Salt Lake City, Utah, USA! Presenting 2 full papers and serving as a Student Volunteer.",
    description: "",
    category: "travel",
    pillarIds: [
      "misalignment",
      "agency"
    ],
    projectIds: []
  },
  {
    date: "Sep 2026",
    type: "award",
    title: "🏅 Named 1 of 10 DBCS Top Seed Award Winners for 2026!",
    description: "Selected as one of 10 <a href=\"https://seedaward.sg/dbcs-seed-award-winners/2026/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">DBCS Top Seed Award</a> winners for 2026 (alongside 115 Seed Award winners), for work on designing responsible Human-AI interaction in sensitive care contexts (peer support and Advance Care Planning).<br/>Kellie demonstrates a commitment to examining how AI can be designed responsibly in sensitive care contexts, particularly mental health (i.e., peer support) and Advance Care Planning (ACP). Both projects were developed with Singapore's care contexts in mind, including local expectations around family involvement, communication, responsibility, help-seeking, and decision-making.<br/>Thank you to all collaborators for the hard work, and thank you to all reviewers for your valuable feedback and support!",
    pillarIds: [
      "reflection"
    ],
    category: "award"
  },
  {
    date: "Jun 2026",
    type: "presentation",
    title: "🇸🇬 Attended SG HCI Meetup 2026 in Singapore! Gave an oral presentation on my peer support research (DIS26 PWiP and CSCW26 full paper).",
    description: "Oral presentation at SG HCI Meetup 2026 on peer support research (DIS26 PWiP and CSCW26 full paper).<br/><a href=\"/files/260618_SG%20HCI%20Meetup%202026.pdf\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">Slides</a>",
    links: {
      slides: "/files/260618_SG%20HCI%20Meetup%202026.pdf"
    },
    pillarIds: [
      "reflection"
    ],
    category: "paper"
  },
  {
    date: "Jun 2026",
    type: "presentation",
    title: "🇸🇬 Attended DIS 2026 in Singapore! Presented 2 PWiP papers and served as a Student Volunteer.",
    pillarIds: [
      "reflection",
      "agency"
    ],
    category: "travel"
  },
  {
    date: "Apr 2026",
    type: "presentation",
    title: "🇪🇸 Attended CHI 2026 in Barcelona, Spain! Presented a full paper and a workshop paper, took part in a workshop and attended a meet-up.",
    pillarIds: [
      "reflection",
      "agency"
    ],
    category: "travel"
  },
  {
    date: "Apr 2026",
    type: "acceptance",
    title: "📣 First-author full paper accepted at CSCW 2026.",
    description: "First-author paper accepted at <a href=\"https://cscw.acm.org/2026/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">CSCW 2026</a>.<br/>📎 'Is This Really a Human Peer Supporter?’: Misalignments Between Peer Supporters and Experts in LLM-Supported Interactions<br/>Thank you to all collaborators for the hard work, and thank you to all reviewers for your valuable feedback and support!",
    pillarIds: [
      "reflection",
      "misalignment"
    ],
    category: "paper"
  },
  {
    date: "Apr 2026",
    type: "acceptance",
    title: "📣 Two first-author PWiP papers accepted at DIS 2026.",
    description: "Two first-author PWiP papers accepted at <a href=\"https://dis.acm.org/2026/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">DIS 2026</a>.<br/>📎 I'm Not Able to Be There for You: Emotional Labour, Responsibility, and AI in Peer Support<br/>📎 Acts of Configuration: Rethinking Provenance, Temporality and Legitimacy in Post-Mortem Agents<br/>Thank you to all collaborators for the hard work, and thank you to all reviewers for your valuable feedback and support!",
    pillarIds: [
      "reflection",
      "agency"
    ],
    category: "paper"
  },
  {
    date: "Mar 2026",
    type: "award",
    title: "🏅 Successfully passed my Qualifying Examination, I'm now a PhD Candidate!",
    description: "Successfully passed my Qualifying Examination, I'm now a PhD cCndidate!<br/>Thank you to all my supervisors, friends, and family for your support and encouragement!",
    category: "paper",
    pillarIds: []
  },
  {
    date: "Mar 2026",
    type: "acceptance",
    title: "📣 Third-author full paper accepted at CSCW 2026.",
    description: "Third-author paper accepted at <a href=\"https://cscw.acm.org/2026/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">CSCW 2026</a>.<br/>📎 Sword and Shield: Uses and Strategies of LLMs in Navigating Disinformation<br/>Thank you to all collaborators for the hard work, and thank you to all reviewers for your valuable feedback and support!",
    pillarIds: [
      "agency"
    ],
    category: "paper"
  },
  {
    date: "Mar 2026",
    type: "award",
    title: "🏅 Our CHI 2026 full paper received an Honourable Mention Award.",
    description: "Honorable Mention awarded at <a href=\"https://chi2026.acm.org/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">CHI 2026</a>.<br/>📎 Words to Describe What I'm Feeling: Exploring the Potential of AI Agents for High Subjectivity Decisions in Advance Care Planning<br/><a href=\"https://programs.sigchi.org/chi/2026/program/content/222310\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">View SIGCHI Programme</a>",
    pillarIds: [
      "reflection"
    ],
    category: "paper"
  },
  {
    date: "Mar 2026",
    type: "acceptance",
    title: "📣 First-author workshop paper accepted at CHI 2026.",
    description: "First-author paper at the <a href=\"https://chi26relationshipai.myportfolio.com/home-1\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">Relationship-Centered Care with AI</a> workshop at CHI 2026.<br/>📎 Redistributing Voice and Responsibility: AI in Relationship-Centred Care",
    pillarIds: [
      "reflection"
    ],
    category: "paper"
  },
  {
    date: "Jan 2026",
    type: "acceptance",
    title: "📣 First-author full paper accepted at CHI 2026.",
    description: "First-author paper accepted at <a href=\"https://chi2026.acm.org/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">CHI 2026</a>.<br/>📎 Words to Describe What I'm Feeling: Exploring the Potential of AI Agents for High Subjectivity Decisions in Advance Care Planning<br/>Thank you to all collaborators for the hard work, and thank you to all reviewers for your valuable feedback and support!",
    category: "paper",
    pillarIds: [
      "reflection"
    ]
  },
  {
    date: "Oct 2025",
    type: "presentation",
    title: "🇳🇴 Attended CSCW 2025 in Bergen, Norway! Presented a poster.",
    description: "Poster presented at <a href=\"https://cscw.acm.org/2025/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">CSCW 2025</a>, in Bergen, Norway 🇳🇴.<br/>📎 Communication Games to Study Emerging Disinformation Scenarios With LLMs",
    category: "travel",
    pillarIds: [
      "agency"
    ]
  },
  {
    date: "Jun 2025",
    type: "acceptance",
    title: "📣 Third-author poster paper accepted at CSCW 2025.",
    description: "Third-author poster accepted at <a href=\"https://cscw.acm.org/2025/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">CSCW 2025</a>.<br/>📎 Communication Games to Study Emerging Disinformation Scenarios With LLMs<br/>Thank you to all collaborators for the hard work, and thank you to all reviewers for your valuable feedback and support!",
    category: "paper",
    pillarIds: [
      "agency"
    ]
  },
  {
    date: "Apr 2025",
    type: "presentation",
    title: "🇯🇵 Attended CHI 2025 in Yokohama, Japan! Presented a workshop paper.",
    description: "Presented at the <a href=\"https://www.hcihealth.org/chi-25-workshop-cfp\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">Interactive Health Workshop</a>, in Yokohama, Japan 🇯🇵.<br/>📎 Envisioning an AI-Enhanced Mental Health Ecosystem",
    category: "travel",
    pillarIds: [
      "reflection"
    ]
  },
  {
    date: "Mar 2025",
    type: "acceptance",
    title: "📣 First-author workshop paper accepted at CHI 2025.",
    description: "First-author paper accepted at the <a href=\"https://www.hcihealth.org/chi-25-workshop-cfp\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">Interactive Health Workshop</a> at CHI 2025.<br/>📎 Envisioning an AI-Enhanced Mental Health Ecosystem",
    category: "paper",
    pillarIds: [
      "reflection"
    ]
  },
  {
    date: "Sep 2024",
    type: "education",
    title: "👩🏻‍💻 Started my PhD at SUTD under the A*STAR ACIS Scholarship.",
    description: "PhD under the <a href=\"https://www.a-star.edu.sg/Scholarships/for-graduate-studies/a-star-cis-scholarship\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">A*STAR ACIS Scholarship</a>.<br/>Supervised by Asst. Prof. Kenny Choo (SUTD) and Dr. Jamie Ng (A*STAR).",
    category: "education",
    pillarIds: []
  },
  {
    date: "Jul 2024",
    type: "presentation",
    title: "🇩🇰 Attended DIS 2024 in Copenhagen, Denmark! Presented a poster.",
    description: "Presented PWiP at <a href=\"https://dis.acm.org/2024/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">DIS 2024</a>, Copenhagen, Denmark 🇩🇰.<br/>📎 Towards Understanding Emotions for Engaged Mental Health Conversations",
    category: "travel",
    pillarIds: [
      "reflection"
    ]
  },
  {
    date: "May 2024",
    type: "acceptance",
    title: "📣 First-author PWiP paper accepted at DIS 2024.",
    description: "First-author PWiP accepted at <a href=\"https://dis.acm.org/2024/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">DIS 2024</a>.<br/>📎 Towards Understanding Emotions for Engaged Mental Health Conversations<br/>Thank you to all collaborators for the hard work, and thank you to all reviewers for your valuable feedback and support!",
    category: "paper",
    pillarIds: [
      "reflection"
    ]
  },
  {
    date: "May 2024",
    type: "education",
    title: "🎓 Graduated from SUTD with a BEng in Computer Science and Design.",
    description: "Bachelor of Engineering (Computer Science and Design) with a Minor in Healthcare Informatics. Also fulfilled the requirements for a Minor in Artificial Intelligence.",
    category: "education",
    pillarIds: []
  },
  {
    date: "Apr 2024",
    type: "award",
    title: "🏅 Awarded the A*STAR Computing and Information Science (ACIS) Scholarship.",
    description: "Awarded the <a href=\"https://www.a-star.edu.sg/Scholarships/for-graduate-studies/a-star-cis-scholarship\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">A*STAR Computing and Information Science (ACIS) Scholarship</a> (renamed to <a href=\"https://www.a-star.edu.sg/scholarships/home/scholarships/ags--scholarship\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">A*STAR Graduate Scholarship (Computing)</a>).",
    category: "education",
    pillarIds: []
  },
  {
    date: "May 2022",
    type: "award",
    title: "🏅 Awarded the A*STAR Research Internship Award (ARIA).",
    description: "Awarded the <a href=\"https://www.a-star.edu.sg/Scholarships/for-undergraduate-studies/a-star-research-internship-award-aria\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">Research Internship Award (ARIA)</a>.<br/>Research attachment at <a href=\"https://www.a-star.edu.sg/bii\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">A*STAR Bioinformatics Institute (BII)</a>.",
    category: "education",
    pillarIds: []
  }
];
